import React from 'react';
import styled from 'styled-components';

import Heading from 'src/commons/components/Heading';

const Body = styled.div`
  max-width: 100%;
  height: 34rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
Body.displayName = 'Body';

export const PageNotFound = () => (
  <Body>
    <Heading>Page Not Found</Heading>
  </Body>
);
